import { defineComponent, onBeforeUnmount, openBlock, createElementBlock, Fragment, createCommentVNode, createElementVNode, mergeProps, unref, createVNode, Transition, toHandlers, withCtx, toDisplayString, renderList, normalizeClass, createBlock } from 'vue';
import { UiSimplebar } from '../simplebar/index.mjs';
import { UiTimePickerPropsOption, UiTimePickerEmits } from './src/component.mjs';
import { useComposable } from './src/composable.mjs';

const _hoisted_1 = { class: "ui-form-candidate-container" };
const _hoisted_2 = { class: "ui-time-picker-candidates" };
const _hoisted_3 = { class: "ui-time-picker-candidate" };
const _hoisted_4 = { class: "ui-candidate-name" };
const _hoisted_5 = { class: "ui-candidate-controls" };
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["onClick"];
const _hoisted_9 = { class: "ui-time-picker-candidate" };
const _hoisted_10 = { class: "ui-candidate-name" };
const _hoisted_11 = { class: "ui-candidate-controls" };
const _hoisted_12 = ["onClick"];
const _hoisted_13 = ["onClick"];
const _hoisted_14 = ["onClick"];
const __default__ = defineComponent({ name: "UiTimePicker" });
var _sfc_main = /* @__PURE__ */ defineComponent({
  ...__default__,
  props: UiTimePickerPropsOption,
  emits: UiTimePickerEmits,
  setup(__props, { expose: __expose, emit: __emit }) {
    const emits = __emit;
    const define = __props;
    const { ons, vars, refs, nodes, binds, methods, computeds } = useComposable(define, emits);
    const { sTime, eTime } = computeds;
    const { show, hidden } = methods;
    const { sHourser, sMinuteser, sSecondser, eHourser, eMinuteser, eSecondser, candidates, container } = nodes;
    const { visible } = refs;
    methods.init();
    onBeforeUnmount(() => {
      var _a;
      (_a = vars.observer) == null ? void 0 : _a.disconnect();
    });
    __expose({ show, hidden });
    ;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(
        Fragment,
        null,
        [
          createCommentVNode(" * \u65F6\u95F4\u9009\u62E9\u5668 "),
          createElementVNode(
            "div",
            mergeProps({
              class: "ui-time-picker",
              ref_key: "container",
              ref: container
            }, unref(binds).container),
            [
              createCommentVNode(" * \u9009\u62E9\u5668\u4E3B\u4F53 "),
              createElementVNode("div", {
                class: "ui-form-control",
                onClick: _cache[0] || (_cache[0] = //@ts-ignore
                (...args) => unref(show) && unref(show)(...args))
              }, [
                createElementVNode(
                  "input",
                  mergeProps({
                    class: "ui-time-context",
                    type: "text",
                    "aria-name": "start"
                  }, unref(binds).start, { readonly: "" }),
                  null,
                  16
                  /* FULL_PROPS */
                ),
                _cache[7] || (_cache[7] = createElementVNode(
                  "div",
                  { class: "ui-time-rect" },
                  null,
                  -1
                  /* HOISTED */
                )),
                createElementVNode(
                  "input",
                  mergeProps({
                    class: "ui-time-context",
                    type: "text",
                    "aria-name": "end"
                  }, unref(binds).end, { readonly: "" }),
                  null,
                  16
                  /* FULL_PROPS */
                )
              ]),
              createCommentVNode(" * \u5019\u9009\u5217\u8868 "),
              createVNode(
                Transition,
                toHandlers(unref(ons).candidates),
                {
                  default: withCtx(() => [
                    unref(visible) ? (openBlock(), createElementBlock(
                      "div",
                      mergeProps({
                        key: 0,
                        class: "ui-form-candidates",
                        ref_key: "candidates",
                        ref: candidates
                      }, unref(binds).candidates),
                      [
                        createElementVNode("div", _hoisted_1, [
                          createElementVNode("div", _hoisted_2, [
                            createElementVNode("div", _hoisted_3, [
                              createElementVNode(
                                "div",
                                _hoisted_4,
                                toDisplayString(_ctx.placeholder.start),
                                1
                                /* TEXT */
                              ),
                              createElementVNode("div", _hoisted_5, [
                                _cache[8] || (_cache[8] = createElementVNode(
                                  "div",
                                  { class: "ui-candidate-division" },
                                  null,
                                  -1
                                  /* HOISTED */
                                )),
                                createVNode(
                                  unref(UiSimplebar),
                                  {
                                    ref_key: "sHourser",
                                    ref: sHourser,
                                    height: 210,
                                    trigger: "Hover",
                                    onScroll: _cache[1] || (_cache[1] = ($event) => unref(methods).scroll(0, unref(sHourser), false))
                                  },
                                  {
                                    default: withCtx(() => [
                                      (openBlock(), createElementBlock(
                                        Fragment,
                                        null,
                                        renderList(24, (_, number) => {
                                          return createElementVNode("div", {
                                            class: normalizeClass(["ui-candidate", { "ui-active": unref(sTime)[0] == number }]),
                                            onClick: ($event) => {
                                              var _a;
                                              return (_a = unref(sHourser)) == null ? void 0 : _a.move(number * 30);
                                            }
                                          }, toDisplayString(number.toString().padStart(2, "0")), 11, _hoisted_6);
                                        }),
                                        64
                                        /* STABLE_FRAGMENT */
                                      ))
                                    ]),
                                    _: 1
                                    /* STABLE */
                                  },
                                  512
                                  /* NEED_PATCH */
                                ),
                                createVNode(
                                  unref(UiSimplebar),
                                  {
                                    ref_key: "sMinuteser",
                                    ref: sMinuteser,
                                    height: 210,
                                    trigger: "Hover",
                                    onScroll: _cache[2] || (_cache[2] = ($event) => unref(methods).scroll(1, unref(sMinuteser), false))
                                  },
                                  {
                                    default: withCtx(() => [
                                      (openBlock(), createElementBlock(
                                        Fragment,
                                        null,
                                        renderList(60, (_, number) => {
                                          return createElementVNode("div", {
                                            class: normalizeClass(["ui-candidate", { "ui-active": unref(sTime)[1] == number }]),
                                            onClick: ($event) => {
                                              var _a;
                                              return (_a = unref(sMinuteser)) == null ? void 0 : _a.move(number * 30);
                                            }
                                          }, toDisplayString(number.toString().padStart(2, "0")), 11, _hoisted_7);
                                        }),
                                        64
                                        /* STABLE_FRAGMENT */
                                      ))
                                    ]),
                                    _: 1
                                    /* STABLE */
                                  },
                                  512
                                  /* NEED_PATCH */
                                ),
                                _ctx.mode != "minutes" ? (openBlock(), createBlock(
                                  unref(UiSimplebar),
                                  {
                                    key: 0,
                                    ref_key: "sSecondser",
                                    ref: sSecondser,
                                    height: 210,
                                    trigger: "Hover",
                                    onScroll: _cache[3] || (_cache[3] = ($event) => unref(methods).scroll(2, unref(sSecondser), false))
                                  },
                                  {
                                    default: withCtx(() => [
                                      (openBlock(), createElementBlock(
                                        Fragment,
                                        null,
                                        renderList(60, (_, number) => {
                                          return createElementVNode("div", {
                                            class: normalizeClass(["ui-candidate", { "ui-active": unref(sTime)[2] == number }]),
                                            onClick: ($event) => {
                                              var _a;
                                              return (_a = unref(sSecondser)) == null ? void 0 : _a.move(number * 30);
                                            }
                                          }, toDisplayString(number.toString().padStart(2, "0")), 11, _hoisted_8);
                                        }),
                                        64
                                        /* STABLE_FRAGMENT */
                                      ))
                                    ]),
                                    _: 1
                                    /* STABLE */
                                  },
                                  512
                                  /* NEED_PATCH */
                                )) : createCommentVNode("v-if", true)
                              ])
                            ]),
                            createElementVNode("div", _hoisted_9, [
                              createElementVNode(
                                "div",
                                _hoisted_10,
                                toDisplayString(_ctx.placeholder.end),
                                1
                                /* TEXT */
                              ),
                              createElementVNode("div", _hoisted_11, [
                                _cache[9] || (_cache[9] = createElementVNode(
                                  "div",
                                  { class: "ui-candidate-division" },
                                  null,
                                  -1
                                  /* HOISTED */
                                )),
                                createVNode(
                                  unref(UiSimplebar),
                                  {
                                    ref_key: "eHourser",
                                    ref: eHourser,
                                    height: 210,
                                    trigger: "Hover",
                                    onScroll: _cache[4] || (_cache[4] = ($event) => unref(methods).scroll(0, unref(eHourser), true))
                                  },
                                  {
                                    default: withCtx(() => [
                                      (openBlock(), createElementBlock(
                                        Fragment,
                                        null,
                                        renderList(24, (_, number) => {
                                          return createElementVNode("div", {
                                            class: normalizeClass(["ui-candidate", { "ui-active": unref(eTime)[0] == number }]),
                                            onClick: ($event) => {
                                              var _a;
                                              return (_a = unref(eHourser)) == null ? void 0 : _a.move(number * 30);
                                            }
                                          }, toDisplayString(number.toString().padStart(2, "0")), 11, _hoisted_12);
                                        }),
                                        64
                                        /* STABLE_FRAGMENT */
                                      ))
                                    ]),
                                    _: 1
                                    /* STABLE */
                                  },
                                  512
                                  /* NEED_PATCH */
                                ),
                                createVNode(
                                  unref(UiSimplebar),
                                  {
                                    ref_key: "eMinuteser",
                                    ref: eMinuteser,
                                    height: 210,
                                    trigger: "Hover",
                                    onScroll: _cache[5] || (_cache[5] = ($event) => unref(methods).scroll(1, unref(eMinuteser), true))
                                  },
                                  {
                                    default: withCtx(() => [
                                      (openBlock(), createElementBlock(
                                        Fragment,
                                        null,
                                        renderList(60, (_, number) => {
                                          return createElementVNode("div", {
                                            class: normalizeClass(["ui-candidate", { "ui-active": unref(eTime)[1] == number }]),
                                            onClick: ($event) => {
                                              var _a;
                                              return (_a = unref(eMinuteser)) == null ? void 0 : _a.move(number * 30);
                                            }
                                          }, toDisplayString(number.toString().padStart(2, "0")), 11, _hoisted_13);
                                        }),
                                        64
                                        /* STABLE_FRAGMENT */
                                      ))
                                    ]),
                                    _: 1
                                    /* STABLE */
                                  },
                                  512
                                  /* NEED_PATCH */
                                ),
                                _ctx.mode != "minutes" ? (openBlock(), createBlock(
                                  unref(UiSimplebar),
                                  {
                                    key: 0,
                                    ref_key: "eSecondser",
                                    ref: eSecondser,
                                    height: 210,
                                    trigger: "Hover",
                                    onScroll: _cache[6] || (_cache[6] = ($event) => unref(methods).scroll(2, unref(eSecondser), true))
                                  },
                                  {
                                    default: withCtx(() => [
                                      (openBlock(), createElementBlock(
                                        Fragment,
                                        null,
                                        renderList(60, (_, number) => {
                                          return createElementVNode("div", {
                                            class: normalizeClass(["ui-candidate", { "ui-active": unref(eTime)[2] == number }]),
                                            onClick: ($event) => {
                                              var _a;
                                              return (_a = unref(eSecondser)) == null ? void 0 : _a.move(number * 30);
                                            }
                                          }, toDisplayString(number.toString().padStart(2, "0")), 11, _hoisted_14);
                                        }),
                                        64
                                        /* STABLE_FRAGMENT */
                                      ))
                                    ]),
                                    _: 1
                                    /* STABLE */
                                  },
                                  512
                                  /* NEED_PATCH */
                                )) : createCommentVNode("v-if", true)
                              ])
                            ])
                          ])
                        ])
                      ],
                      16
                      /* FULL_PROPS */
                    )) : createCommentVNode("v-if", true)
                  ]),
                  _: 1
                  /* STABLE */
                },
                16
                /* FULL_PROPS */
              )
            ],
            16
            /* FULL_PROPS */
          )
        ],
        2112
        /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
      );
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=index.vue2.mjs.map
